import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './bordered-tooltip.scss';

const BorderedTooltip = ({ children, style, className, offset }) => {
  style.top -= offset;
  return (<div className={classNames(styles.container, className)} style={style}>
    {children}
    <span className={styles.triangle}/>
  </div>);
};

BorderedTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  offset: PropTypes.number,
};

BorderedTooltip.defaultProps = {
  offset: 10,
};

export default BorderedTooltip;



// WEBPACK FOOTER //
// ./app/components/bordered-tooltip/bordered-tooltip.js